import React, { memo } from 'react';
import { View, Image } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';
import { Button } from '@redlink/components/molecules';

export const ListContainerPlaceholder = memo(
  ({ imageSource, description, actions = [] }) => {
    const { styles } = useStyle();
    const hasAction = actions.length > 0;
    return (
      <View style={styles.container}>
        {imageSource && (
          <Image
            source={imageSource}
            style={styles.image}
            resizeMode="contain"
          />
        )}
        {description && (
          <>
            <Space />
            <Text style={styles.descriptionText}>{description}</Text>
          </>
        )}
        {hasAction && (
          <>
            <Space />
            <Button style={styles.actionContainer} {...actions[0]} />
          </>
        )}
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    alignItems: 'center',
  },
  image: {
    width: 250,
    height: 180,
  },
  descriptionText: {
    fontSize: 14,
    color: colors.gray23,
  },
  actionContainer: {
    paddingHorizontal: 40,
    height: 50,
  },
}));
